import React from "react";
import SmartExtractFilterActions from "./SmartExtractFilterActions";
import SmartExtractFilterFidelityPlanSelect from "./SmartExtractFilterFidelityPlanSelect";

const SmartExtractFilter = () => {
	return (
		<div className="smart-extract-filter">
			<div className="smart-extract-filter--pills-and-buttons">
				<SmartExtractFilterFidelityPlanSelect />
				<SmartExtractFilterActions />
			</div>
		</div>
	);
};

export default SmartExtractFilter;
